import { createStore, compose, applyMiddleware } from 'redux';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import createOidcMiddleware, { loadUser } from 'redux-oidc';
import { routerMiddleware as createRouterMiddleware } from 'connected-react-router';
import rootReducer from './modules';
import initSaga from './initSaga';
import userManager from './utils/userManager';

export const history = createBrowserHistory();

export default function configureStore() {
  // create the saga middleware.
  const sagaMiddleware = createSagaMiddleware();
  // oidc middleware
  const oidcMiddleware = createOidcMiddleware(userManager);

  const routerMiddleware = createRouterMiddleware(history);

  const middlewares = [routerMiddleware, sagaMiddleware, oidcMiddleware];
  // eslint-disable-next-line no-underscore-dangle
  const reduxDevToolsEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const initialState = {};
  // mount the saga on the store.
  const store = createStore(
    rootReducer(history),
    initialState,
    reduxDevToolsEnhancer(applyMiddleware(...middlewares)),
  );
  loadUser(store, userManager);
  // Then run the saga.
  initSaga(sagaMiddleware);
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./modules', () => {
      // We need to reload the root reducer to hot reload the code
      // eslint-disable-next-line global-require
      const nextRootReducer = require('./modules').default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}
